// Day-stable pseudo-randomness. Shared by the home feed and the category
// sections so both reshuffle together, once per day (#6).

// Small deterministic PRNG (mulberry32) so a given seed always yields the same
// sequence — used to shuffle once per day instead of on every load.
export function mulberry32(seed: number): () => number {
  let a = seed >>> 0;
  return () => {
    a |= 0;
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

// Seed derived from the local calendar day (YYYYMMDD) → the order is stable
// across refreshes and reshuffles automatically at midnight.
export function dailySeed(now: Date): number {
  return now.getFullYear() * 10000 + (now.getMonth() + 1) * 100 + now.getDate();
}

// Seeded Fisher–Yates shuffle into a new array.
export function shuffled<T>(list: readonly T[], seed: number): T[] {
  const a = [...list];
  const rand = mulberry32(seed);
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(rand() * (i + 1));
    [a[i], a[j]] = [a[j]!, a[i]!];
  }
  return a;
}
